import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CustomSvg from '../svgs/CustomSvg';
// import '../dashboard/dashboard.css';

const ComingSoonModal = ({ show, onHide, feature }) => {
  const [animate, setAnimate] = useState(false);
  
  useEffect(() => {
    if (show) {
      // Add a small delay before starting animation for better visual effect
      const timer = setTimeout(() => setAnimate(true), 100);
      return () => clearTimeout(timer);
    } else {
      setAnimate(false);
    }
  }, [show]);

  // Handle the close action
  const handleClose = () => {
    // First set animation state to false to trigger exit animation
    setAnimate(false);
    
    // Delay the actual closing to allow for exit animation
    setTimeout(() => {
      if (onHide && typeof onHide === 'function') {
        onHide();
      }
    }, 200);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="coming-soon-modal"
      backdrop={true}
      backdropClassName="coming-soon-backdrop"
    >
      <div 
        style={{
          background: 'linear-gradient(145deg, #1A0F3D 0%, #130828 100%)',
          borderRadius: '16px',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
          border: '1px solid rgba(95, 56, 194, 0.3)',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
          transform: animate ? 'scale(1)' : 'scale(0.9)',
          opacity: animate ? 1 : 0
        }}
      >
        <Modal.Header className="border-0 pb-0" style={{ padding: '16px' }}>
          <div className="w-100 d-flex justify-content-end">
            <Button 
              variant="link" 
              onClick={handleClose} 
              className="p-0 m-0 border-0 position-relative close-btn"
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                transition: 'all 0.2s ease',
                zIndex: 10
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
            >
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                <CustomSvg name="x" color="#FFF" />
              </div>
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body className="text-center py-4" style={{ 
          padding: '0 24px 32px',
          alignContent: 'center',
          alignItems: 'center', 
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: '100%',
          minHeight: '320px',
        }}>
         <div 
  className={`mb-4 ${animate ? 'animate-bounce' : ''}`}
  style={{
    animation: animate ? 'floatUpDown 3s ease-in-out infinite' : 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '200px', // 👈 give it a fixed or min height
    position: 'relative',
  }}
>

            <div 
              style={{
                position: 'absolute',
                width: '160px',
                height: '30px',
                background: 'rgba(134, 35, 239, 0.3)',
                borderRadius: '50%',
                filter: 'blur(15px)',
                bottom: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
                animation: animate ? 'pulseShadow 3s ease-in-out infinite' : 'none',
                placeContent: 'center',
              }}
            />
        <img 
  src="/images/coming-soon.svg" 
  alt="Coming Soon" 
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = "https://placehold.co/160x160/8623EF/ffffff?text=Coming+Soon";
  }}
  style={{
    width: '160px', 
    height: '160px',
    objectFit: 'contain',
    borderRadius: '50%',
    border: '2px solid rgba(134, 35, 239, 0.5)',
    boxShadow: '0 10px 30px rgba(134, 35, 239, 0.3)',
    filter: 'drop-shadow(0 5px 15px rgba(134, 35, 239, 0.5))',
    position: 'relative',
    zIndex: 5,
  }}
            />
          </div>
          <h3 
            className="modal-title mb-3" 
            style={{ 
              color: '#FFFFFF',
              fontSize: '28px',
              fontWeight: '700',
              opacity: animate ? 1 : 0,
              transform: animate ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.5s ease 0.2s'
            }}
          >
            Coming Soon!
          </h3>
          <p 
            className="modal-subtitle mb-4 text-capitalize"
            style={{ 
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '16px',
              lineHeight: '1.5',
              opacity: animate ? 1 : 0,
              transform: animate ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.5s ease 0.3s',
              maxWidth: '280px',
              margin: '0 auto 28px'
            }}
          >
            {feature ? `${feature} will be available soon` : 'This feature will be available soon'}
          </p>
          <Button 
            onClick={handleClose} 
            className="w-100 close-btn" 
            style={{ 
              background: 'linear-gradient(90deg, #8623EF 0%, #A553F9 100%)',
              border: 'none',
              borderRadius: '12px',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              boxShadow: '0 4px 15px rgba(134, 35, 239, 0.3)',
              opacity: animate ? 1 : 0,
              transform: animate ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.5s ease 0.4s',
              position: 'relative',
              overflow: 'hidden',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(134, 35, 239, 0.5)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(134, 35, 239, 0.3)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ position: 'relative', zIndex: 2 }}>OK, I'll Check Back Later</span>
            <div 
              style={{
                position: 'absolute',
                top: '0',
                left: '-100%',
                width: '200%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%)',
                transition: 'all 0.5s ease',
                zIndex: 1
              }}
              className="button-shine"
            />
          </Button>
        </Modal.Body>
      </div>
      <style jsx="true">{`
        @keyframes floatUpDown {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes pulseShadow {
          0%, 100% { opacity: 0.3; transform: translateX(-50%) scale(1); }
          50% { opacity: 0.5; transform: translateX(-50%) scale(1.1); }
        }
        
        .coming-soon-modal .modal-content {
          background: transparent;
          border: none;
        }
        
        .animate-bounce {
          animation: floatUpDown 3s ease-in-out infinite;
        }
        
        .button-shine:hover {
          left: 100%;
        }
        
        /* Make modal background darker and more transparent */
        .modal-backdrop.show {
          opacity: 0.85 !important;
          background-color: #080510 !important;
        }
        
        /* Ensure modal is above other elements */
        .coming-soon-modal {
          z-index: 1050 !important;
        }
        
        .coming-soon-backdrop {
          z-index: 1040 !important;
        }
        
        /* Ensure buttons are clickable */
        .close-btn {
          cursor: pointer !important;
          z-index: 1060 !important;
        }
      `}</style>
    </Modal>
  );
};

export default ComingSoonModal;
